import SuperAdminRoute from "../modual/SuperAdmin/SuperAdminRoute";
import SuperAdminMenuList from '../components/menu-list/SuperAdminMenuList';

const Auths = [
  {
    key: 1,
    role: "SUPERADMIN",
    name: "SUPER ADMIN",
    access: [1],
    filePath: <SuperAdminRoute />,
    menuList: SuperAdminMenuList
  },
  
];
export default Auths;
